<template>
  <BasicAlert
    v-if="warningRNCPVisible"
    alertType="warning"
    :alertLabel="messageRncpAlerte"
  />
</template>

<script setup lang="ts">
  import { ref, watch } from 'vue'
  import type { LovItemDTO, RncpDto } from '@/features/api/extranet/dto/Lov'

  const messageRncpAlerte = ref<string>()
  const warningRNCPVisible = ref(false)

  const props = withDefaults(
    defineProps<{
      rncp: LovItemDTO<string> | null | undefined
      dateConclusion: string | null | undefined
      isAvenant?: boolean
      readonly?: boolean
      getRncp: (code: string) => Promise<RncpDto | null>
    }>(),
    {
      isAvenant: false,
    },
  )

  watch(
    () => ({
      dateConclusion: props.dateConclusion,
      rncp: props.rncp?.code,
      isAvenant: props.isAvenant,
      readonly: props.readonly,
    }),
    async () => {
      messageRncpAlerte.value =
        'Le code RNCP sélectionné ne semble plus actif sur le référentiel FRANCE COMPÉTENCES, nous vous invitons à revoir la certification (RNCP) de cette formation.'

      if (props.readonly || !props.rncp?.code || !props.rncp?.intitule || !props.dateConclusion) {
        warningRNCPVisible.value = false
        return
      }

      // Fetch
      const rncp = await props.getRncp(props.rncp.code)

      if (rncp?.certificationDeRemplacement && rncp?.certificationDeRemplacement?.length > 0) {
        messageRncpAlerte.value = `Le code RNCP sélectionné ne semble plus actif sur le référentiel FRANCE COMPÉTENCES. Ce code ${rncp!.code} a été remplacé par le ${rncp!.certificationDeRemplacement!.at(0)!.code} . Nous vous invitons à le modifier pour poursuivre la saisie.`
      }

      if (rncp?.dateDecision && rncp.dateDecision > props.dateConclusion) {
        messageRncpAlerte.value =
          'Le code RNCP sélectionné ne semble pas actif à la date de conclustion du contrat sur le référentiel FRANCE COMPÉTENCES. Nous vous invitons à le modifier. A défaut, nous ne pourrons engager le contrat et une relance vous sera transmise.'

        warningRNCPVisible.value = true
        return
      }

      if (rncp?.dateFinEnregistrement) {
        warningRNCPVisible.value = rncp.dateFinEnregistrement < props.dateConclusion && props.isAvenant === false
        return
      }

      if (rncp?.estActif === false) {
        warningRNCPVisible.value = true
        return
      }

      warningRNCPVisible.value = false
    },
    { immediate: true },
  )
</script>
